import { Keys as CommonKeys } from './common';
import { Keys as HubspotKeys } from './hubspot';
import { Keys as JobAdderKeys } from './jobAdder';
import { Keys as MSDynamics365SalesKeys } from './msDynamics365Sales';
import { Keys as PipedriveKeys } from './pipedrive';
import { Keys as SFKeys } from './sf';

export const IntegrationKeys = {
  Hubspot: HubspotKeys,
  SF: SFKeys,
  Pipedrive: PipedriveKeys,
  MSDynamics365Sales: MSDynamics365SalesKeys,
  JobAdder: JobAdderKeys,
  Common: CommonKeys,
};
